import "babel-polyfill";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/slick"

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {accordion} from "./modules/accordion";
import {partnersSlider} from "./modules/partnersSlider";
import {popups} from "./modules/popups";
import {fullHeightPage} from "./modules/fullHeightPage";
import {headerMenuAndSticky} from "./modules/headerMenuAndSticky";
import {customSelect} from "./modules/customSelect";
import {animationOnScroll} from "./modules/animations";
import {welcomePopup} from "./modules/welcomePopup";
import {contactsForm} from "./modules/contactsForm";
import {plans} from "./modules/plans";
import {joinForm} from "./modules/joinForm";
import {sliderReports} from "./modules/sliderReports";
import {filtersPosts} from "./modules/filtersPosts";
import {filtersReports} from "./modules/filterReports";
import {loadSuccessStory} from "./modules/loadSuccessStory";
import {hero} from "./modules/hero";
import {team} from "./modules/team";

binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": headerMenuAndSticky,
        ".accordion": accordion,
        ".partners": partnersSlider,
        ".popups": popups,
        "select": customSelect,
        ".has-animation": animationOnScroll,
        ".welcome-popup": welcomePopup,
        ".wpcf7-form": contactsForm,
        ".plans": plans,
        ".join-form": joinForm,
        ".slider-reports": sliderReports,
        ".posts-section:not(.reports-section)": filtersPosts,
        ".reports-section": filtersReports,
        ".success-stories-section": loadSuccessStory,
        ".hero-section": hero,
        ".section-team": team
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js